import React, { useEffect, useState, useMemo } from "react";
import {
  Card, CardBody, Col, Container, Row, Modal, ModalHeader, ModalBody, ModalFooter,
  Label, Input, Form, Badge, Spinner, Button, UncontrolledTooltip,
  Nav, NavItem, NavLink, TabContent, TabPane
} from "reactstrap";
import classnames from "classnames";
import TableContainer from "../../../components/Common/TableContainer";
import Breadcrumbs from "components/Common/Breadcrumb";
import { ToastContainer, toast } from "react-toastify";
import { Link } from "react-router-dom";

const KullaniciListesi = () => {
  document.title = "Kullanıcı Listesi | HarmanaGEL Admin";

  const BASE_URL = "https://harmanagelapi.stechomeyazilim.info";

  const [users, setUsers] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  
  // Modal State'leri
  const [editModal, setEditModal] = useState(false);
  const [viewModal, setViewModal] = useState(false);
  const [activeViewTab, setActiveViewTab] = useState("1");
  const [activeEditTab, setActiveEditTab] = useState("1"); // Düzenleme Modalı Sekmeleri
  
  const [selectedUser, setSelectedUser] = useState(null); // Düzenleme için state
  const [detailedUser, setDetailedUser] = useState(null); // Görüntüleme için state
  const [isDetailsLoading, setIsDetailsLoading] = useState(false);
  const [isSaving, setIsSaving] = useState(false);

  const authUser = JSON.parse(localStorage.getItem("authUser"));
  const isAdmin = authUser?.HESAP_TURU === 'Admin';

  useEffect(() => {
    if (isAdmin) fetchUsers();
  }, [isAdmin]);

  const fetchUsers = async () => {
    setIsLoading(true);
    try {
      const response = await fetch(`${BASE_URL}/KULLANICILAR?$orderby=ID desc`);
      const result = await response.json();
      setUsers(result.value || []);
    } catch (error) {
      toast.error("Kullanıcılar yüklenemedi.");
    } finally {
      setIsLoading(false);
    }
  };

  // --- GÖRÜNTÜLEME MODALI AÇILIŞI ---
  const handleViewProfile = async (user) => {
    setViewModal(true);
    setIsDetailsLoading(true);
    setActiveViewTab("1");
    try {
      const response = await fetch(
        `${BASE_URL}/KULLANICILAR?$filter=ID eq ${user.ID}&$expand=KULLANICI_ADRESLERI,KULLANICI_SERTIFIKALARI,FATURA_BILGILERI,MAGAZALAR`
      );
      const result = await response.json();
      if (result.value && result.value.length > 0) setDetailedUser(result.value[0]);
    } catch (error) {
      toast.error("Profil detayları yüklenemedi.");
    } finally {
      setIsDetailsLoading(false);
    }
  };

  // --- DÜZENLEME MODALI AÇILIŞI (TÜM VERİLERİ ÇEK) ---
  const handleEditProfile = async (user) => {
    setEditModal(true);
    setIsDetailsLoading(true);
    setActiveEditTab("1");
    try {
      const response = await fetch(
        `${BASE_URL}/KULLANICILAR?$filter=ID eq ${user.ID}&$expand=KULLANICI_ADRESLERI,KULLANICI_SERTIFIKALARI,FATURA_BILGILERI,MAGAZALAR`
      );
      const result = await response.json();
      const fullUser = result.value?.[0];

      if (fullUser) {
        setSelectedUser({
          ID: fullUser.ID,
          AD_SOYAD: fullUser.AD_SOYAD || "",
          Mail_Adress: fullUser.Mail_Adress || "",
          CEP_NO: fullUser.CEP_NO || "",
          AKTIF_DURUM: fullUser.AKTIF_DURUM,

          Address_ID: fullUser.KULLANICI_ADRESLERI?.[0]?.ID,
          City: fullUser.KULLANICI_ADRESLERI?.[0]?.IL || "",
          District: fullUser.KULLANICI_ADRESLERI?.[0]?.ILCE || "",
          AddressText: fullUser.KULLANICI_ADRESLERI?.[0]?.ACIK_ADRES || "",

          License_ID: fullUser.KULLANICI_SERTIFIKALARI?.[0]?.ID,
          License_Class: fullUser.KULLANICI_SERTIFIKALARI?.[0]?.SERTIFIKA_ADI || "",
          License_No: fullUser.KULLANICI_SERTIFIKALARI?.[0]?.SERTIFIKA_NO || "",

          Company_ID: fullUser.MAGAZALAR?.[0]?.ID,
          Company_Name: fullUser.MAGAZALAR?.[0]?.MAGAZA_ADI || "",

          Invoice_ID: fullUser.FATURA_BILGILERI?.[0]?.ID,
          Tax_No: fullUser.FATURA_BILGILERI?.[0]?.VERGI_NO || "",
          Tax_Office: fullUser.FATURA_BILGILERI?.[0]?.VERGI_DAIRESI || "",

          Bank_ID: fullUser.FATURA_BILGILERI?.[0]?.ID,
          IBAN: fullUser.FATURA_BILGILERI?.[0]?.IBAN || "",
          Bank_Name: fullUser.FATURA_BILGILERI?.[0]?.BANKA_ADI || ""
        });
      }
    } catch (error) {
      toast.error("Düzenlenecek profil detayları yüklenemedi.");
      setEditModal(false);
    } finally {
      setIsDetailsLoading(false);
    }
  };

  // --- TÜM BİLGİLERİ GÜNCELLEME (ÇOKLU API İSTEĞİ) ---
  const handleEditSubmit = async () => {
    if (!selectedUser) return;
    setIsSaving(true);

    try {
      const uid = selectedUser.ID;

      // 1. ANA KULLANICI GÜNCELLEMESİ (PATCH)
      const userPromise = fetch(`${BASE_URL}/KULLANICILAR(${uid})`, {
        method: "PATCH", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          AD_SOYAD: selectedUser.AD_SOYAD,
          Mail_Adress: selectedUser.Mail_Adress,
          CEP_NO: selectedUser.CEP_NO,
          AKTIF_DURUM: selectedUser.AKTIF_DURUM
        }),
      });

      // 2. ADRES GÜNCELLEMESİ / EKLENMESİ
      const addressPayload = { KULLANICI_ID: uid, IL: selectedUser.City, ILCE: selectedUser.District, ACIK_ADRES: selectedUser.AddressText };
      const addressPromise = selectedUser.Address_ID
        ? fetch(`${BASE_URL}/KULLANICI_ADRESLERI(${selectedUser.Address_ID})`, { method: "PATCH", headers: { "Content-Type": "application/json" }, body: JSON.stringify(addressPayload) })
        : fetch(`${BASE_URL}/KULLANICI_ADRESLERI`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(addressPayload) });

      // 3. SERTİFİKA GÜNCELLEMESİ / EKLENMESİ
      const licensePayload = { KULLANICI_ID: uid, SERTIFIKA_ADI: selectedUser.License_Class, SERTIFIKA_NO: selectedUser.License_No };
      const licensePromise = selectedUser.License_ID
        ? fetch(`${BASE_URL}/KULLANICI_SERTIFIKALARI(${selectedUser.License_ID})`, { method: "PATCH", headers: { "Content-Type": "application/json" }, body: JSON.stringify(licensePayload) })
        : fetch(`${BASE_URL}/KULLANICI_SERTIFIKALARI`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(licensePayload) });

      // 4. FATURA / BANKA GÜNCELLEMESİ / EKLENMESİ
      const bankPayload = { KULLANICI_ID: uid, IBAN: selectedUser.IBAN, BANKA_ADI: selectedUser.Bank_Name, VERGI_NO: selectedUser.Tax_No, VERGI_DAIRESI: selectedUser.Tax_Office };
      const bankPromise = selectedUser.Bank_ID
        ? fetch(`${BASE_URL}/FATURA_BILGILERI(${selectedUser.Bank_ID})`, { method: "PATCH", headers: { "Content-Type": "application/json" }, body: JSON.stringify(bankPayload) })
        : fetch(`${BASE_URL}/FATURA_BILGILERI`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(bankPayload) });

      // 5. MAĞAZA GÜNCELLEMESİ / EKLENMESİ
      let companyPromise = Promise.resolve();
      if (selectedUser.Company_ID) {
        companyPromise = fetch(`${BASE_URL}/MAGAZALAR(${selectedUser.Company_ID})`, {
          method: "PATCH", headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ MAGAZA_ADI: selectedUser.Company_Name })
        });
      } else if (selectedUser.Company_Name) {
        companyPromise = fetch(`${BASE_URL}/MAGAZALAR`, {
          method: "POST", headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ KULLANICI_ID: uid, MAGAZA_ADI: selectedUser.Company_Name, OLUSTURMA_TARIHI: new Date().toISOString() })
        });
      }
      const invoicePromise = Promise.resolve();

      // Tüm istekleri paralel yolla
      await Promise.all([userPromise, addressPromise, licensePromise, bankPromise, companyPromise, invoicePromise]);

      toast.success("Kullanıcının tüm bilgileri başarıyla güncellendi.");
      setEditModal(false);
      fetchUsers(); // Tabloyu yenile

    } catch (error) {
      console.error("Güncelleme Hatası:", error);
      toast.error("Güncelleme sırasında bir hata oluştu.");
    } finally {
      setIsSaving(false);
    }
  };

  const handleChange = (field, value) => {
    setSelectedUser(prev => ({ ...prev, [field]: value }));
  };

 const columns = useMemo(() => [
    { header: "ID", accessorKey: "ID", cell: (c) => <strong>#{c.getValue()}</strong> },
    {
      header: "Ad Soyad",
      accessorKey: "AD_SOYAD",
      cell: (c) => (
        <div className="d-flex align-items-center">
          <div className="avatar-xs me-2">
            <span className="avatar-title rounded-circle bg-primary-subtle text-primary">{c.getValue()?.charAt(0)}</span>
          </div>
          {c.getValue()}
        </div>
      ),
    },
    { header: "E-posta", accessorKey: "Mail_Adress" },
    { header: "Rol", accessorKey: "Users_Type.Users_Type_Title", cell: (c) => <Badge color="info" pill>{c.getValue()}</Badge> },
    {
      header: "Durum",
      accessorKey: "AKTIF_DURUM",
      cell: (c) => <Badge color={c.getValue() ? "success" : "danger"}>{c.getValue() ? "Aktif" : "Pasif"}</Badge>
    },
    {
      header: "Aksiyon",
      cell: (cellProps) => {
        const user = cellProps.row.original;
        return (
          <div className="d-flex gap-3">
            {/* KAPSAMLI DÜZENLE BUTONU */}
            <Button color="link" className="p-0 text-success" onClick={() => handleEditProfile(user)}>
              <i className="mdi mdi-pencil font-size-18" id={`edit-${user.ID}`} />
            </Button>
            
            <Button color="link" className="p-0 text-primary" onClick={() => handleViewProfile(user)}>
              <i className="mdi mdi-eye font-size-18" id={`view-${user.ID}`} />
            </Button>
            
            <Link to={`/kullanici-aktiviteleri/${user.ID}`} className="p-0 text-warning border-0 bg-transparent">
              <i className="mdi mdi-clipboard-list-outline font-size-18" id={`history-${user.ID}`} />
            </Link>

            <UncontrolledTooltip target={`edit-${user.ID}`}>Tüm Bilgileri Düzenle</UncontrolledTooltip>
            <UncontrolledTooltip target={`view-${user.ID}`}>Kişisel Profili Gör</UncontrolledTooltip>
            <UncontrolledTooltip target={`history-${user.ID}`}>Sistem Aktiviteleri (İşler/Teklifler)</UncontrolledTooltip>
          </div>
        );
      }
    }
  ], []);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Yönetim" breadcrumbItem="Kullanıcı Listesi" />
          <Card>
            <CardBody>
              {isLoading ? <div className="text-center py-5"><Spinner color="primary" /></div> : (
             <TableContainer
                columns={columns}
                data={users || []}
                isGlobalFilter={true}
                isPagination={true}
                customPageSize={users.length < 10 ? users.length : 10} 
                SearchPlaceholder="Kullanıcı ara..."
                tableClass="align-middle table-nowrap table-hover"
                theadClass="table-light"
                paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                pagination="pagination pagination-rounded justify-content-end mb-2"
              />
              )}
            </CardBody>
          </Card>
        </Container>

        {/* ========================================================================= */}
        {/* --- MODAL: KAPSAMLI KULLANICI DÜZENLEME --- */}
        {/* ========================================================================= */}
        <Modal isOpen={editModal} toggle={() => setEditModal(false)} centered size="lg">
          <ModalHeader toggle={() => setEditModal(false)} className="bg-light">
            <i className="mdi mdi-account-edit text-success me-2"></i> Kullanıcıyı Düzenle (#{selectedUser?.ID})
          </ModalHeader>
          <ModalBody className="p-0">
            {isDetailsLoading ? <div className="text-center py-5"><Spinner color="success" /></div> : selectedUser && (
              <div className="bg-light-subtle pb-3">
                <Nav tabs className="nav-tabs-custom nav-justified bg-white pt-2">
                  <NavItem><NavLink className={classnames("fw-bold", { active: activeEditTab === "1" })} onClick={() => setActiveEditTab("1")} style={{cursor:'pointer'}}>Genel Bilgiler</NavLink></NavItem>
                  <NavItem><NavLink className={classnames("fw-bold", { active: activeEditTab === "2" })} onClick={() => setActiveEditTab("2")} style={{cursor:'pointer'}}>Adres</NavLink></NavItem>
                  <NavItem><NavLink className={classnames("fw-bold", { active: activeEditTab === "3" })} onClick={() => setActiveEditTab("3")} style={{cursor:'pointer'}}>Ehliyet</NavLink></NavItem>
                  <NavItem><NavLink className={classnames("fw-bold", { active: activeEditTab === "4" })} onClick={() => setActiveEditTab("4")} style={{cursor:'pointer'}}>Şirket & Finans</NavLink></NavItem>
                </Nav>

                <TabContent activeTab={activeEditTab} className="p-4">
                  {/* DÜZENLE: GENEL BİLGİLER */}
                  <TabPane tabId="1">
                    <Row>
                        <Col md={6} className="mb-3">
                            <Label className="fw-bold">Ad Soyad</Label>
                            <Input type="text" value={selectedUser.AD_SOYAD} onChange={(e) => handleChange("AD_SOYAD", e.target.value)} />
                        </Col>
                        <Col md={6} className="mb-3">
                            <Label className="fw-bold">E-posta Adresi</Label>
                            <Input type="email" value={selectedUser.Mail_Adress} onChange={(e) => handleChange("Mail_Adress", e.target.value)} />
                        </Col>
                        <Col md={6} className="mb-3">
                            <Label className="fw-bold">Telefon Numarası</Label>
                            <Input type="text" value={selectedUser.CEP_NONumber} onChange={(e) => handleChange("CEP_NONumber", e.target.value)} />
                        </Col>
                        <Col md={6} className="mb-3">
                            <Label className="fw-bold d-block">Sistem Durumu</Label>
                            <div className="form-check form-switch form-switch-lg mb-3" dir="ltr">
                                <Input type="checkbox" className="form-check-input" checked={selectedUser.AKTIF_DURUM} onChange={(e) => handleChange("AKTIF_DURUM", e.target.checked)} />
                                <Label className="form-check-label fw-medium ms-2 mt-1">
                                {selectedUser.AKTIF_DURUM ? <span className="text-success">Aktif Kullanıcı</span> : <span className="text-danger">Hesap Dondurulmuş</span>}
                                </Label>
                            </div>
                        </Col>
                    </Row>
                  </TabPane>

                  {/* DÜZENLE: ADRES BİLGİLERİ */}
                  <TabPane tabId="2">
                    <Row>
                        <Col md={6} className="mb-3">
                            <Label className="fw-bold">İl / Şehir</Label>
                            <Input type="text" placeholder="Örn: İstanbul" value={selectedUser.City} onChange={(e) => handleChange("City", e.target.value)} />
                        </Col>
                        <Col md={6} className="mb-3">
                            <Label className="fw-bold">İlçe</Label>
                            <Input type="text" placeholder="Örn: Kadıköy" value={selectedUser.District} onChange={(e) => handleChange("District", e.target.value)} />
                        </Col>
                        <Col md={12}>
                            <Label className="fw-bold">Açık Adres</Label>
                            <Input type="textarea" rows="3" value={selectedUser.AddressText} onChange={(e) => handleChange("AddressText", e.target.value)} />
                        </Col>
                    </Row>
                  </TabPane>

                  {/* DÜZENLE: EHLİYET BİLGİLERİ */}
                  <TabPane tabId="3">
                    <Row>
                        <Col md={6} className="mb-3">
                            <Label className="fw-bold">Ehliyet Sınıfı</Label>
                            <Input type="text" placeholder="Örn: B, C, E" value={selectedUser.License_Class} onChange={(e) => handleChange("License_Class", e.target.value)} />
                        </Col>
                        <Col md={6} className="mb-3">
                            <Label className="fw-bold">Ehliyet Numarası</Label>
                            <Input type="text" value={selectedUser.License_No} onChange={(e) => handleChange("License_No", e.target.value)} />
                        </Col>
                    </Row>
                  </TabPane>

                  {/* DÜZENLE: ŞİRKET & FİNANS */}
                  <TabPane tabId="4">
                    <h6 className="text-primary border-bottom pb-2 mb-3">Şirket ve Vergi Bilgileri</h6>
                    <Row>
                        <Col md={12} className="mb-3">
                            <Label className="fw-bold">Şirket Adı / Ünvanı</Label>
                            <Input type="text" value={selectedUser.Company_Name} onChange={(e) => handleChange("Company_Name", e.target.value)} />
                        </Col>
                        <Col md={6} className="mb-3">
                            <Label className="fw-bold">Vergi Numarası / T.C. No</Label>
                            <Input type="text" value={selectedUser.Tax_No} onChange={(e) => handleChange("Tax_No", e.target.value)} />
                        </Col>
                        <Col md={6} className="mb-3">
                            <Label className="fw-bold">Vergi Dairesi</Label>
                            <Input type="text" value={selectedUser.Tax_Office} onChange={(e) => handleChange("Tax_Office", e.target.value)} />
                        </Col>
                    </Row>

                    <h6 className="text-primary border-bottom pb-2 my-3">Banka Hesabı</h6>
                    <Row>
                        <Col md={6} className="mb-3">
                            <Label className="fw-bold">Banka Adı</Label>
                            <Input type="text" placeholder="Örn: Garanti BBVA" value={selectedUser.Bank_Name} onChange={(e) => handleChange("Bank_Name", e.target.value)} />
                        </Col>
                        <Col md={6} className="mb-3">
                            <Label className="fw-bold">IBAN Numarası</Label>
                            <Input type="text" placeholder="TR..." value={selectedUser.IBAN} onChange={(e) => handleChange("IBAN", e.target.value)} />
                        </Col>
                    </Row>
                  </TabPane>
                </TabContent>
              </div>
            )}
          </ModalBody>
          <ModalFooter className="bg-light">
            <Button color="secondary" outline onClick={() => setEditModal(false)} disabled={isSaving}>İptal</Button>
            <Button color="success" onClick={handleEditSubmit} disabled={isSaving || isDetailsLoading}>
              {isSaving ? <Spinner size="sm" className="me-2" /> : <i className="mdi mdi-content-save me-1"></i>}
              Tüm Değişiklikleri Kaydet
            </Button>
          </ModalFooter>
        </Modal>

        {/* ========================================================================= */}
        {/* --- MODAL: PROFİL GÖR (SALT OKUNUR) --- */}
        {/* ========================================================================= */}
        <Modal isOpen={viewModal} toggle={() => setViewModal(false)} centered size="xl">
          <ModalHeader toggle={() => setViewModal(false)}>
            <i className="bx bx-user-circle me-2"></i> Kullanıcı Profili Detayı
          </ModalHeader>
          <ModalBody className="bg-light-subtle">
            {isDetailsLoading ? <div className="text-center py-5"><Spinner color="primary" /></div> : detailedUser && (
              <>
                <Nav tabs className="nav-tabs-custom nav-justified mb-3 bg-white">
                  <NavItem><NavLink className={classnames({ active: activeViewTab === "1" })} onClick={() => setActiveViewTab("1")} style={{cursor:'pointer'}}>Genel</NavLink></NavItem>
                  <NavItem><NavLink className={classnames({ active: activeViewTab === "2" })} onClick={() => setActiveViewTab("2")} style={{cursor:'pointer'}}>Ehliyet</NavLink></NavItem>
                  <NavItem><NavLink className={classnames({ active: activeViewTab === "3" })} onClick={() => setActiveViewTab("3")} style={{cursor:'pointer'}}>Şirket & Banka</NavLink></NavItem>
                  <NavItem><NavLink className={classnames({ active: activeViewTab === "4" })} onClick={() => setActiveViewTab("4")} style={{cursor:'pointer'}}>Belgeler</NavLink></NavItem>
                </Nav>

                <TabContent activeTab={activeViewTab}>
                  <TabPane tabId="1">
                    <Card><CardBody>
                      <Row>
                        <Col md={4} className="border-end">
                            <Label className="text-muted mb-0">Ad Soyad</Label><p className="fw-bold">{detailedUser.AD_SOYAD}</p>
                            <Label className="text-muted mb-0">E-posta</Label><p className="fw-bold">{detailedUser.Mail_Adress}</p>
                            <Label className="text-muted mb-0">Telefon</Label><p className="fw-bold">{detailedUser.CEP_NONumber || "---"}</p>
                        </Col>
                        <Col md={8}>
                            <Label className="text-muted mb-0">Adres</Label>
                            <p>{detailedUser.Users_Address?.[0]?.Users_Address_AdressText || "Bilgi Yok"}</p>
                            <p>{detailedUser.Users_Address?.[0]?.Users_Address_City} / {detailedUser.Users_Address?.[0]?.Users_Address_Dist}</p>
                        </Col>
                      </Row>
                    </CardBody></Card>
                  </TabPane>

                  <TabPane tabId="2">
                    <Card><CardBody>
                      <Row>
                        <Col md={6}><Label className="text-muted mb-0">Ehliyet Sınıfı</Label><p className="fw-bold">{detailedUser.Users_Driving_License?.[0]?.Driving_License_Class || "---"}</p></Col>
                        <Col md={6}><Label className="text-muted mb-0">Ehliyet Numarası</Label><p className="fw-bold">{detailedUser.Users_Driving_License?.[0]?.Driving_License_Number || "---"}</p></Col>
                      </Row>
                    </CardBody></Card>
                  </TabPane>

                  <TabPane tabId="3">
                    <Card><CardBody>
                      <h6 className="text-primary border-bottom pb-2">Şirket Bilgileri</h6>
                      <p><strong>Firma:</strong> {detailedUser.Users_Company?.[0]?.Users_Company_Name || "Kayıtlı Şirket Yok"}</p>
                      <p><strong>Vergi No:</strong> {detailedUser.Users_Company?.[0]?.Users_Invoince?.[0]?.KdvNumber || "---"}</p>
                      <p><strong>Vergi Dairesi:</strong> {detailedUser.Users_Company?.[0]?.Users_Invoince?.[0]?.VergiDairesi || "---"}</p>
                      <h6 className="text-primary border-bottom pb-2 mt-4">Banka Bilgileri</h6>
                      <p><strong>IBAN:</strong> {detailedUser.Users_BankAccount?.[0]?.Users_BankAccount_Iban || "---"}</p>
                      <p><strong>Banka:</strong> {detailedUser.Users_BankAccount?.[0]?.Users_BankAccount_BankName || "---"}</p>
                    </CardBody></Card>
                  </TabPane>

                  <TabPane tabId="4">
                    <Row>
                        {[
                            { n: "Kimlik", u: detailedUser.Users_Document?.[0]?.Identity_Url },
                            { n: "Ehliyet", u: detailedUser.Users_Document?.[0]?.License_Url },
                            { n: "Sabıka Kaydı", u: detailedUser.Users_Document?.[0]?.Criminalrecord_Url },
                            { n: "Vergi Levhası", u: detailedUser.Users_Document?.[0]?.Taxplate_Url }
                        ].map((doc, i) => (
                            <Col md={3} key={i}>
                                <Card className="text-center border shadow-none">
                                    <CardBody>
                                        <i className="mdi mdi-file-pdf-outline display-4 text-danger"></i>
                                        <p className="mt-2 fw-medium">{doc.n}</p>
                                        {doc.u ? <a href={doc.u} target="_blank" rel="noreferrer" className="btn btn-sm btn-soft-primary w-100">Görüntüle</a> : <Badge color="light" className="w-100">Yüklenmemiş</Badge>}
                                    </CardBody>
                                </Card>
                            </Col>
                        ))}
                    </Row>
                  </TabPane>
                </TabContent>
              </>
            )}
          </ModalBody>
        </Modal>
      </div>
      <ToastContainer autoClose={2000} />
    </React.Fragment>
  );
};

export default KullaniciListesi;